import React, { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";

const EmailCapture = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      if (res.already_subscribed) {
        toast("You're already on the list.");
      } else {
        toast.success("On the list. Drops, boot pairings and team offers inbound.");
      }
      setEmail("");
    } catch {
      toast.error("Couldn't sign you up. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-ink text-white" data-testid="email-capture">
      <div className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-7">
          <p className="overline text-white/60 mb-4">Early Access</p>
          <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
            Get early access
            <br />
            to new <span className="text-pritch-volt-trim">colourways.</span>
          </h2>
          <p className="mt-6 max-w-md text-white/70 leading-relaxed">
            Join the Pritch list for product drops, boot-pairing guides, team offers and early
            access to new pitch wear.
          </p>
        </div>
        <div className="md:col-span-5">
          <form
            onSubmit={onSubmit}
            className="flex border border-white/30"
            data-testid="email-capture-form"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-transparent px-4 py-4 text-sm placeholder:text-white/40 focus:outline-none"
              data-testid="email-capture-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-pritch-volt-trim text-ink px-6 text-[11px] tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors disabled:opacity-50"
              data-testid="email-capture-submit"
            >
              {loading ? "Joining…" : "Join the list"}
            </button>
          </form>
          <p className="mono text-[10px] text-white/40 mt-3">No spam. One thoughtful email per drop.</p>
        </div>
      </div>
    </section>
  );
};

export default EmailCapture;
